import { ImmomioButtonComponent } from '@immomio/ui/button';
import {
  Component,
  inject,
  Input,
  input,
  OnInit,
  DestroyRef,
  ChangeDetectionStrategy
} from '@angular/core';

import {
  FormArray,
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule
} from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { SelfDisclosureQuestion } from '@ui/shared/model';
import { TranslatePipe } from '@ngx-translate/core';

import { SelfDisclosureService } from '../../self-disclosure.service';
import { SelfDisclosureChildComponent } from '../self-disclosure-child/self-disclosure-child.component';

import { getArrayListValidator } from '../../../components/legacy/form/controls/validation/validators';

@Component({
  selector: 'app-self-disclosure-child-list',
  templateUrl: './self-disclosure-child-list.component.html',
  styleUrls: ['./self-disclosure-child-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ImmomioButtonComponent,
    FormsModule,
    ReactiveFormsModule,
    SelfDisclosureChildComponent,
    TranslatePipe
  ]
})
export class SelfDisclosureChildListComponent implements OnInit {
  #destroyRef = inject(DestroyRef);
  private fb = inject(FormBuilder);
  private selfDisclosureService = inject(SelfDisclosureService);

  private _selfDisclosureQuestion: SelfDisclosureQuestion;
  @Input()
  get selfDisclosureQuestion() {
    return this._selfDisclosureQuestion;
  }

  set selfDisclosureQuestion(value) {
    this._selfDisclosureQuestion = { ...value };
  }

  readonly form = input<FormGroup>(undefined);
  readonly showBirthdate = input(true);

  public get getFormControls() {
    return (this.getFormArray.controls as FormGroup[]) || [];
  }

  private get getAnswerUnavailable() {
    return this.form().get('answerUnavailable');
  }

  private get getFormArray() {
    return this.form().get('answer') as FormArray;
  }

  public ngOnInit() {
    this.getAnswerUnavailable.valueChanges
      .pipe(takeUntilDestroyed(this.#destroyRef))
      .subscribe(value => {
        this.selfDisclosureQuestion.answerUnavailable =
          this.getAnswerUnavailable.value;
        this.updateValidity(value);
      });
    this.updateValidity(this.selfDisclosureQuestion.answerUnavailable);
  }

  public removeChild(index: number) {
    this.getFormArray.removeAt(index);
  }

  public addChild() {
    const childConfig = this.selfDisclosureService.getChildConfig(
      this.selfDisclosureQuestion.mandatory &&
        this.selfDisclosureQuestion.showSelfDisclosureQuestions,
      this.showBirthdate()
    );
    const childGroup = this.fb.group(childConfig);
    const subQuestionsArray = childGroup.get('subQuestions') as FormArray;

    (this.selfDisclosureQuestion.subQuestions || [])
      .filter(subQuestion => subQuestion.showSelfDisclosureQuestions)
      .forEach(subQuestion => {
        const config = this.selfDisclosureService.getConfigForSubQuestion(
          subQuestion.type,
          subQuestion.mandatory
        );
        const formGroup: FormGroup = this.fb.group(config);
        formGroup.patchValue(subQuestion);
        subQuestionsArray.push(formGroup);
      });

    this.getFormArray.push(childGroup);
  }

  private updateValidity(value: boolean) {
    /**
     * Here we add or remove the validators to show the red border only if field is invalid
     */
    if (value) {
      this.getFormArray.clearValidators();
    } else {
      this.getFormArray.setValidators(
        getArrayListValidator(
          this.selfDisclosureQuestion.mandatory &&
            this.selfDisclosureQuestion.showSelfDisclosureQuestions
        )
      );
    }
    this.getFormArray.updateValueAndValidity();
  }
}
